import React, { Dispatch, SetStateAction, useMemo } from 'react';
import { VideoPlayer as VideoPlayerComponent, VideoPlayerPlayPausePlacement } from '@vimily/bonjoro-ui-components-v2/VideoPlayer';
import { Modal, ModalProps } from '@vimily/bonjoro-ui-components-v2/Modal';
import { Transcript } from '~/types/models';
export interface VideoPlayerProps {
  src: string;
  transcript?: Transcript;
  setOpen: Dispatch<SetStateAction<boolean>>;
  isOpen: boolean;
}

export default function VideoPlayer({
  src,
  transcript,
  isOpen,
  setOpen,
}: VideoPlayerProps) {
  const modalProps = useMemo<ModalProps>(() => {
    return {
      open: isOpen,
      onModalClose: () => setOpen(false),
      className: 'max-w-[600px] !p-0 !rounded-xl',
      overlayClassName: 'p-8 !z-[9999999999]',
      hideCloseButton: true,
    };
  }, [isOpen, src]);

  return (
    <Modal {...modalProps}>
      <VideoPlayerComponent
        containerClassName='w-full rounded-none md:rounded-[10px]'
        videoClassName='w-full bg-white w-[400px] h-[400px] md:min-w-[600px] md:min-h-[600px]'
        videoUrl={src}
        hideClose
        hideFullScreen
        hideMuteUnmute
        hideNewTab
        rounded
        showProgressBar
        transcription={transcript?.captions?.sentences}
        playPausePlacement={VideoPlayerPlayPausePlacement.Center}
      />
    </Modal>
  );
}
